import Button from "@material-tailwind/react/Button";
import H3 from "@material-tailwind/react/Heading3";
import H5 from "@material-tailwind/react/Heading5";
import React from 'react';
import { FaGithub, FaGooglePlay, FaHackerrank, FaLinkedin, FaMedium } from 'react-icons/fa';
import Fade from 'react-reveal/Fade';

const Hero = () => {
    return (
        <div className="h-screen w-full bg-white flex items-center justify-between">
            <Fade left>
                <div className="lg:ml-12 md:ml-8 lg:w-1/4 md:w-2/4 w-full flex flex-col xl:items-start lg:items-start md:items-center sm:items-center">
                    <H3 color="lightBlue">Hello, I'm Shakib Uddin</H3>
                    <H5 color="gray">Software Engineer</H5>
                    <div className="w-full flex lg:justify-start md:justify-center justify-center my-4">
                        <Button
                            color="lightBlue"
                            buttonType="filled"
                            size="regular"
                            rounded={false}
                            block={false}
                            iconOnly={false}
                            ripple="light"
                            className="mr-2 "
                            onClick={() => {
                                console.log("hello")
                                document.getElementById('projects').scrollIntoView({
                                    behavior: 'smooth'
                                });
                            }}
                        >
                            See My Works
                        </Button>
                        <a href="https://drive.google.com/file/d/1ypoSmmieuo-loOowLsQqXcNY_JDLkZDM/view?usp=sharing" target="_blank" rel="noopener noreferrer"> <Button
                            color="lightBlue"
                            buttonType="outline"
                            size="regular"
                            rounded={false}
                            block={false}
                            iconOnly={false}
                            ripple="dark"
                        >
                            Resume
                        </Button></a>

                    </div>
                    <div className="w-full flex lg:justify-start md:justify-center justify-center">
                        <a className="mr-2" target="_blank" href="https://github.com/ShakibUddin" rel="noreferrer"><FaGithub className="text-4xl text-black" /></a>
                        <a className="mr-2" target="_blank" href="https://www.linkedin.com/in/md-shakib-uddin" rel="noreferrer"><FaLinkedin className="text-4xl text-blue-600" /></a>
                        <a className="mr-2" target="_blank" href="https://shakibuddinbhuiyan.medium.com/" rel="noreferrer"><FaMedium className="text-4xl text-black" /></a>
                        <a className="mr-2" target="_blank" href="https://www.hackerrank.com/Shakib__Uddin" rel="noreferrer"><FaHackerrank className="text-4xl text-green-500" /></a>
                        <a className="mr-2" target="_blank" href="https://play.google.com/store/apps/developer?id=Carnage+Apps" rel="noreferrer"><FaGooglePlay className="text-4xl text-blue-500" /></a>
                    </div>
                </div>
            </Fade>
            <Fade right>
                <div className="w-3/4 lg:flex md:flex hidden">
                    <img className="w-full" src="https://media.giphy.com/media/Y4ak9Ki2GZCbJxAnJD/source.gif" alt="" />
                </div>
            </Fade>
        </div>
    );
};

export default Hero;